import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useModal } from "@/modals"
import { GameProvider } from "@/providers/GameProvider"
import { Button } from "@/ui/Button"
import { MatchLogs } from "@/ui/MatchLogs"
import { Modal } from "@/ui/Modal"
import styles from "./MatchLogsModal.module.scss"

const modalType = "matchLogs"

export const MatchLogsModal: FC = () => {
  const { t } = useTranslation()
  const { modal } = useModal(modalType)

  const closeModal = () => {
    modal.close()
  }

  return (
    <Modal.Center
      type={modalType}
      className={clsx(styles.MatchLogsModal)}
      body={{ className: styles.MatchLogsModal_body }}
      onClose={closeModal}
    >
      <Modal.StoneFlexContainer
        content={{ className: styles.MatchLogsModal_content }}
        outside={
          <>
            <div className={clsx(styles.MatchLogsModal_buttons)}>
              <Button
                className={clsx(styles.MatchLogsModal_button)}
                styles="green"
                onClick={closeModal}
              >
                {t("button.close")}
              </Button>
            </div>
          </>
        }
      >
        <GameProvider>
          <MatchLogs />
        </GameProvider>
      </Modal.StoneFlexContainer>
    </Modal.Center>
  )
}
